import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifiConnectedNoInternet4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_connected_no_internet_4"}/>
}
